module.exports = __webpack_public_path__ + "4e829ba5ab2fa6fd8ad26702783d0071.png";